import { useState } from 'react';
import PropTypes from 'prop-types';

import { Collapsible } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import './HowToBookSection.scss';

export const HowToBookCollapsableSection = ({
  Icon,
  title,
  content,
  extraContent = null,
  isCollapsed = true
}) => {
  const [collapsed, setCollapsed] = useState(isCollapsed);

  const handleCollapsedChange = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className="how-to-book-section">
      <div className="how-to-book-section__icon how-to-book-section__icon--ds">
        {Icon}
      </div>
      <div className="how-to-book-section__text how-to-book-section__text--collapsible">
        <Collapsible
          onCollapsedChange={handleCollapsedChange}
          headerClassName="how-to-book-section__collapsible-header"
          bodyClassName="how-to-book-section__collapsible-body"
          hasIcon
          isCollapsed={collapsed}
          renderHeader={() => (
            <span className="how-to-book-section__title how-to-book-section__title--collapsible">
              {trans(title)}
            </span>
          )}
          renderBody={() => (
            <span className="how-to-book-section__body">{trans(content)}</span>
          )}
        />
        {extraContent}
      </div>
    </div>
  );
};

HowToBookCollapsableSection.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  extraContent: PropTypes.node,
  Icon: PropTypes.node.isRequired,
  isCollapsed: PropTypes.bool
};

export const HowToBookSection = ({
  Icon,
  title,
  content,
  extraContent = null
}) => (
  <div className="how-to-book-section">
    <div className="how-to-book-section__icon">{Icon}</div>
    <div className="how-to-book-section__text">
      <span className="how-to-book-section__title">{trans(title)}</span>
      <span className="how-to-book-section__body">
        {trans(content)}
        {extraContent}
      </span>
    </div>
  </div>
);

HowToBookSection.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  extraContent: PropTypes.node,
  Icon: PropTypes.node.isRequired
};

export default {
  HowToBookCollapsableSection,
  HowToBookSection
};
